import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  IAddPurchaseRequest,
  IPurchase,
  IPurchaseRequest,
  IPurchaseResponse,
} from "./purchase.interface";
import {
  addPurchaseService,
  deletePurchaseService,
  getPurchasesService,
  getPurchaseService,
  updatePurchaseService,
} from "./purchase.service";

export const getPurchases = createAsyncThunk<
  IPurchaseResponse,
  IPurchaseRequest,
  { rejectValue: any }
>("purchase/getPurchases", async (payload, { rejectWithValue }) => {
  try {
    const { page, limit, sort, order, search } = payload ?? {};

    const data = await getPurchasesService(
      page ?? 0,
      limit ?? 10,
      sort ?? "inserted",
      order ?? "desc",
      search ?? ""
    );

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});

export const getPurchase = createAsyncThunk<
  IPurchase,
  string,
  { rejectValue: any }
>("purchase/getPurchase", async (id, { rejectWithValue }) => {
  try {
    const data = await getPurchaseService(id);

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});

export const updatePurchase = createAsyncThunk<
  IPurchase,
  { id: string; payload: IPurchase },
  { rejectValue: any }
>("purchase/updatePurchase", async ({ id, payload }, { rejectWithValue }) => {
  try {
    const data = await updatePurchaseService(id, payload);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});

export const deletePurchase = createAsyncThunk<
  IPurchase,
  string,
  { rejectValue: any }
>("purchase/deletePurchase", async (id, { rejectWithValue }) => {
  try {
    const data = await deletePurchaseService(id);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});

export const addPurchase = createAsyncThunk<
  IPurchase,
  IAddPurchaseRequest,
  { rejectValue: any }
>("purchase/addPurchase", async (payload, { rejectWithValue }) => {
  try {
    const data = await addPurchaseService(payload);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});
